/**
 * Created by vladislav on 06.11.2019
 */

CookieManCell.prototype.upDuration = function () {
    return 1600;
};